{
  "overridesEnabledBadgeLabel": "Überschreibungen an",
  "releaseBadgeAlpha": "Alpha",
  "releaseBadgeBeta": "Beta",
  "releaseBadgeDev": "Entw.",
  "releaseBadgePoc": "POC"
}
